import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Unique identifier for the input and label association */
  id: PropTypes.string.isRequired,
  /** Label to display for the size tile */
  label: PropTypes.node.isRequired,
  /** Name attribute for the input element. Used to group radio buttons or checkboxes */
  name: PropTypes.string.isRequired,
  /** Callback fired when the tile is selected or deselected */
  onChange: PropTypes.func.isRequired,
  /** Input type: `radio` for single selection, `checkbox` for multi-selection */
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  /** Value of the size tile input */
  value: PropTypes.string.isRequired,
  /** If true, applies disabled style to the tile (visual only, does not disable input) */
  hasDisabledStyle: PropTypes.bool,
  /** If true, the tile is selected (checked) */
  isChecked: PropTypes.bool,
  /** If true, disables the input and prevent interaction */
  isDisabled: PropTypes.bool,
  /** If true, marks the tile as unavailable (for visual indication, does not disable input) */
  isUnavailable: PropTypes.bool,
  /** Controls visual size of the tile. `default` for standard, `long` for extended width */
  size: PropTypes.oneOf(['default', 'long'])
};
function SizeTile(_ref) {
  var hasDisabledStyle = _ref.hasDisabledStyle,
    id = _ref.id,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    isUnavailable = _ref.isUnavailable,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    size = _ref.size,
    type = _ref.type,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sitg-input-inner-wrapper",
    "data-state": hasDisabledStyle ? 'disabled' : null,
    "data-size": size,
    "data-testid": "sitg-input-inner-wrapper",
    "data-variant": isUnavailable ? 'unavailable' : null
  }, /*#__PURE__*/React__default.createElement("input", {
    checked: isChecked,
    className: "sitg-input",
    disabled: isDisabled,
    id: id,
    name: name,
    onChange: onChange,
    type: type,
    value: value
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sitg-label-outer",
    "data-testid": "sitg-label-outer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sitg-label-wrapper",
    "data-testid": "sitg-label-wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "sitg-label",
    "data-testid": "sitg-label",
    htmlFor: id
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "sitg-label-text"
  }, label)))));
}
SizeTile.propTypes = propTypes;

export { SizeTile as default };
//# sourceMappingURL=SizeTile.js.map
